import { RRegimeDimensionnementSchema_Type } from '@batical/types/src'
import { fetchGenericSorted, fetchGeneric } from './GenericQ'

const RRegimeDimensionnement: Array<RRegimeDimensionnementSchema_Type> = require('../json/RegimeDimensionnement.json')
export function fetchRegimeDimensionnementSorted(): Array<{
  value: string
  label: string
}> {
  return fetchGenericSorted(RRegimeDimensionnement)
}

export function fetchRegimeDimensionnement(uuid: string): RRegimeDimensionnementSchema_Type {
  return fetchGeneric(RRegimeDimensionnement, uuid)
}
